/** 목록 응답과 등록 프리뷰가 같은 역 하나를 고른다. */
export interface StationClinic {
    stationName?: string | null;
    stations?: { id: string; name: string }[] | null;
}

export const stationChip = (clinic?: StationClinic): string | undefined => {
    const name = clinic?.stationName?.trim() || [...(clinic?.stations ?? [])]
        .sort((a, b) => a.id.localeCompare(b.id))
        .find((station) => station.name.trim())?.name.trim();
    return name ? `🚇 ${name.endsWith('역') ? name : `${name}역`}` : undefined;
};

/** 당일 지급 칩 글 — 서버 PayTiming.SAME_DAY 표시와 같다. 칩 줄에서 이 칩만 강조색으로 그린다 */
export const SAME_DAY_PAY_CHIP: string = '당일 지급';

/**
 * 카드 칩 줄(docs/recruitment-alba-improve-plan.md 3장, 한 줄·넘치면 +N):
 * - 당일 지급 공고: `역 → 당일 지급 → 급여`(복지 숨김) — 2026-10-05 사용자 결정
 * - 그 밖: `역 → 급여 → 복지`(복지가 없으면 경력 → 직급). 급여는 서버 payChip(금액만, 협의·내규는 "급여 협의"·"급여 내규")
 * - 서버가 payChip 을 주지 않으면(옛 응답) 예전 규칙 `역 → 복지`(복지가 없으면 급여 → 경력 → 직급)
 */
export const recruitmentChips = (
    clinic?: StationClinic,
    welfares?: { description: string }[],
    infoChips?: string[],
    sameDayPay?: boolean,
    payChip?: string | null,
): string[] => {
    const station = stationChip(clinic);
    const head: string[] = station ? [station] : [];
    const info: string[] = (infoChips ?? []).filter((chip: string) => chip !== SAME_DAY_PAY_CHIP);
    if (sameDayPay) {
        const pay: string | undefined = payChip ?? info[0];
        return [...head, SAME_DAY_PAY_CHIP, ...(pay ? [pay] : [])];
    }
    const welfareChips: string[] = (welfares ?? []).map((welfare) => welfare.description);
    if (payChip) return [...head, payChip, ...(welfareChips.length > 0 ? welfareChips : info.filter((chip: string) => chip !== payChip))];
    return [...head, ...(welfareChips.length > 0 ? welfareChips : infoChips ?? [])];
};

/** 칩 줄에서 강조할 칩 — 당일 지급 공고만 */
export const accentChipOf = (sameDayPay?: boolean): string | undefined => (sameDayPay ? SAME_DAY_PAY_CHIP : undefined);

/** 좁은 폭에서도 끝까지 남기는 칩 — 급여·당일 지급(역·복지가 먼저 접힌다, 계약서 3-1) */
export const pinnedChipsOf = (sameDayPay?: boolean, payChip?: string | null, infoChips?: string[]): string[] => {
    const pay: string | undefined = payChip ?? (sameDayPay ? (infoChips ?? []).find((chip: string) => chip !== SAME_DAY_PAY_CHIP) : undefined);
    return [...(sameDayPay ? [SAME_DAY_PAY_CHIP] : []), ...(pay ? [pay] : [])];
};
